<template>
    <ScoreContainer class="scores_container" :pose="containerIsVisible ? 'visible' : 'hidden'" >
        <div class="score_label">{{ scoreLabel }}</div>
        <div class="scores_rounds" :class="scoreColor">
            <scoreCircle class="skill_score_container"  :class="{isRef: isRef(1), active: active1}" >
                <div class="score_round">1</div>
            </scoreCircle>
            <scoreCircle class="skill_score_container"  :class="{isRef: isRef(2), active: active2}" >
                <div class="score_round">2</div>
            </scoreCircle>
            <scoreCircle class="skill_score_container"  :class="{isRef: isRef(3), active: active3}" >
                <div class="score_round">3</div>
            </scoreCircle>
            <scoreCircle class="skill_score_container"  :class="{isRef: isRef(4), active: active4}" >
                <div class="score_round">4</div>
            </scoreCircle>
            
        </div>
    </ScoreContainer>
</template>

<script>
import posed from 'vue-pose';

export default {
    name: 'GameRulesScore',
    props: ['score', 'refScore', 'scoreDelay', 'scoreLabel', 'scoreDecal'],
    components: {
        ScoreContainer: posed.div({
            visible: {
                opacity: 1,
                x: 0,
                beforeChildren: false,
                staggerChildren: 150
            },
            hidden: {
                opacity: 0,
                x: '-100%',
                afterChildren: true
            }
        }),
        scoreCircle: posed.div({
            visible: { opacity: 1, scale: 1 },
            hidden: { opacity: 0.5, scale: 0 },
            hoverable: true,
            init: { scale: 0.2 }
        })
    },
    data(){
        return {
            containerIsVisible: false,
            active1: false,
            active2: false,
            active3: false,
            active4: false,
            active5: false
        }
    },
    mounted(){
        setTimeout(() => {
            this.containerIsVisible = true;
        }, this.scoreDecal+(this.scoreDelay * 100) );
        if(this.score.toFixed(0) >= 1){
            this.active1 = true
        }
        if(this.score.toFixed(0) >= 2){
            this.active2 = true
        }
        if(this.score.toFixed(0) >= 3){
            this.active3 = true
        }
        if(this.score.toFixed(0) >= 4){
            this.active4 = true
        }
        if(this.score.toFixed(0) >= 5){
            this.active5 = true
        }
    },
    computed: {
        scoreColor(){
            const deltaScores = this.refScore.toFixed(0) - this.score.toFixed(0)
            if (deltaScores == 0 || deltaScores == -0){ return {'color_1': true} }
            if (deltaScores == 1 || deltaScores == -1){ return {'color_2': true} }
            if (deltaScores == 2 || deltaScores == -2){ return {'color_3': true} }
            if (deltaScores == 3 || deltaScores == -3){ return {'color_4': true} }
            if (deltaScores == 4 || deltaScores == -4){ return {'color_5': true} }
        }
    },
    methods: {
        isRef(val){
            return this.refScore.toFixed(0) == val
        }
    }
}
</script>

<style lang="scss" scoped>
.scores_container{
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    position: relative;
    padding: 12px 0;
    .score_label{
        // padding-right: 30px;
        // text-align: right;
        padding-bottom: 12px;
    }
    .scores_rounds{
        display: flex;
        position: relative;
        &.color_1{
            .skill_score_container.active{
                .score_round{
                    background-color: $score-diff1;
                }
            }
        }
        &.color_2{
            .skill_score_container.active{
                .score_round{
                    background-color: $score-diff2;
                }
            }
        }
        &.color_3{
            .skill_score_container.active{
                .score_round{
                    background-color: $score-diff3;
                }
            }
        }
        &.color_4{
            .skill_score_container.active{
                .score_round{
                    background-color: $score-diff4;
                }
            }
        }
        &.color_5{
            .skill_score_container.active{
                .score_round{
                    background-color: $score-diff5;
                }
            }
        }
    }
    .skill_score_container{
        position: relative;
        &.isRef:before{
            z-index: 1;
            content: "";
            border-radius: 100%;
            position: absolute;
            height: 62px;
            width: 62px;
            line-height: 62px;
            top: -6px;
            left: -6px;
            border: 3px solid black;
        }
        .score_round{
            z-index: 5;
            height: 50px;
            width: 50px;
            background-color: $grey-lighter;
            border-radius: 100%;
            text-align: center;
            line-height: 50px;
            color: white;
            font-weight: 600;
            font-size: 1.2rem;
            position: relative;
            transition: .3s all;
        }
        &.active{
            .score_round{
                background-color: $primary;
            }
        }
    }
    &.ui_hide_ref{
        .scores_rounds{
            .skill_score_container.active{
                .score_round{
                    background-color: $info!important;
                }
            }
            .skill_score_container.isRef:before{
                border: 3px solid transparent!important;
            }
        }
    }
}
</style>
